import React, { useContext, useState } from 'react';
import { Button, Modal, Typography } from 'antd';

import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { USER_ENDPOINT } from '@totem/utilities/endpoints';

const { Paragraph, Title } = Typography;

type Props = {
  onAcknowledged: () => void;
};

const EulaDialog = ({ onAcknowledged }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [isSending, setIsSending] = useState<boolean>(false);

  const handleAcknowledge = () => {
    setIsSending(true);

    fetch(`${USER_ENDPOINT}/preferences/eulaAcknowledged`, {
      method: 'POST',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
      body: 'true',
    }).then(() => {
      setIsSending(false);

      onAcknowledged();
    });
  };

  return (
    <Modal
      open
      closable={false}
      title={<Title level={4}>Notice of Rights, Restrictions and Data</Title>}
      footer={
        <Button type="primary" loading={isSending} onClick={handleAcknowledge}>
          I Acknowledge
        </Button>
      }
    >
      <Paragraph>
        By accessing this network, you confirm that the device you are using
        meets the following security requirements:
      </Paragraph>
      <Paragraph>
        <ul>
          <li>
            It is protected with reputable antivirus/anti-malware software and
            an active firewall.
          </li>
          <li>It is regularly updated and patched.</li>
          <li>
            It uses strong passwords and, where available, two-factor
            authentication.
          </li>
          <li>
            It is used only for authorized business purposes and does not engage
            in personal or unrelated activity while connected.
          </li>
        </ul>
      </Paragraph>
      <Paragraph>
        Unauthorized or non-compliant access may result in loss of access
        privileges.
      </Paragraph>
    </Modal>
  );
};

export default EulaDialog;
